'use strict';

export const cookieConsentElements = () => ({
    allowCookiesButton: document.querySelector('#allow-cookies'),
    disallowCookiesButton: document.querySelector('#disallow-cookies'),
    bar: document.querySelector('div#cookie-consent')
});
